import React from "react";
import { render } from "react-dom";
import { classNamePrefix as prefixCt } from "@/utils/common";
import { CatalogView } from "./catalogView";

const HEAD_LEVEL = 7;

const getCatalog = ($conatiner) => {
  const $headingNodes = $conatiner.querySelectorAll("h1, h2, h3, h4, h5, h6");
  const catalog = [];

  let maxLevel = 0;
  let minLevel = HEAD_LEVEL;

  $headingNodes.forEach(($node) => {
    if ($node.textContent === null) {
      return;
    }

    const text = $node.textContent.replace(/\s/g, "").replace(/#/g, "");

    if (!text) {
      return;
    }

    const level = parseInt($node.nodeName.slice(1), 10);

    if (level > maxLevel) {
      maxLevel = level;
    }
    if (level < minLevel) {
      minLevel = level;
    }

    catalog.push({
      key: $node.id,
      text: $node.textContent,
      level,
      scrollIntoView: () => $node.scrollIntoView(),
    });
  });
  return { catalog, minLevel };
};

export default class catalogRender {
  fragmentCls: string;

  config: Record<string, any>;

  constructor(config = {}) {
    this.fragmentCls = `.${prefixCt("edit-catalog")}`;
    this.config = config;
  }

  containerRender = ($conatiner: HTMLElement) => {
    const { catalog, minLevel } = getCatalog($conatiner);
    const catalogNodes = $conatiner.querySelectorAll(this.fragmentCls);
    catalogNodes.forEach((node) => {
      const style = node.getAttribute("data-style") || "none";
      const newNode = document.createElement("div");
      node.parentNode.insertBefore(newNode, node.nextSibling);
      render(
        <CatalogView style={style} catalog={catalog} minLevel={minLevel} />,
        newNode
      );
      node.parentNode.removeChild(node);
    });
  };
}
